var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFilterIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "stroke-miter-limit": 10,
    viewBox: "0 0 500 500",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M345.219 8.563c-32.657 0-60.237 21.683-69.157 51.437H32.937C20.262 60 10 70.262 10 82.938V83c0 12.675 10.262 22.937 22.938 22.938h244.687c10.229 27.439 36.59 47.031 67.594 47.031 31.006 0 57.366-19.59 67.593-47.031h50.376c12.675-.001 22.968-10.263 22.968-22.938v-.063c0-12.675-10.293-22.937-22.968-22.937h-48.844c-8.92-29.753-36.469-51.438-69.125-51.438zM82.125 177.812C42.25 177.813 9.937 210.125 9.937 250s32.313 72.188 72.188 72.188c31.833-.001 58.802-20.622 68.406-49.219h312.657c12.675 0 22.968-10.262 22.968-22.938v-.062c0-12.676-10.293-22.938-22.968-22.938H150.531c-9.604-28.597-36.573-49.219-68.406-49.219zM250 345.938c-31.683-.001-58.559 20.425-68.281 48.812H32.938C20.261 394.75 10 405.043 10 417.719v.031c0 12.675 10.262 22.969 22.938 22.969h148.5c9.481 28.812 36.576 49.625 68.562 49.625 31.986 0 59.081-20.813 68.562-49.625h144.626c12.675 0 22.968-10.294 22.968-22.969v-.031c0-12.676-10.293-22.969-22.968-22.969H318.281c-9.722-28.387-36.598-48.812-68.281-48.812z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFilterIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "filter-icon.6dd8a09db90ba1bd5e1f642094e0174c.svg";